import { useCallback, useEffect, useMemo } from "react";

import { useEditor } from "@craftjs/core";

import { useBlocksDefinitionContext } from "@/modules/cms/views/post/components/builder/context";

function useBlockDefinition() {
  const { query: { node: getNode } } = useEditor()

  const { value: definitions, setValue: setDefinitions } = useBlocksDefinitionContext()

  const setDefinition = useCallback(definition => {
    if (!definition?.key) return;
    setDefinitions(definitions => ({
      ...definitions,
      [definition.key]: definition,
    }))
  }, [setDefinitions])

  const getDefinition = useCallback(id => {
    const { data } = getNode(id).get() || {}
    const { name: key } = data || {}

    if (!key) {
      return null
    }

    return definitions[key]
  }, [getNode, definitions])

  return useMemo(() => ({
    setDefinition,
    getDefinition,
  }), [setDefinition, getDefinition])
}

function BlockDefinition({ definition, children }) {
  const { setDefinition } = useBlockDefinition()

  useEffect(() => {
    if (definition?.key) {
      setDefinition(definition)
    }
  }, [definition, setDefinition])

  return children
}

export {
  useBlockDefinition,
  BlockDefinition,
}
